import { Button, Modal, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { FC, useState } from "react";
import { formatEquation } from "../utils/equationFormatter";
import ReadOnlyEquationView from "./ReadOnlyEquationView";

// Small icon CTA dropped next to an equation's label (Target Equation / Imported equation) —
// opens a centered, read-only modal showing the SAME Prettify-formatted (multi-line, indented)
// text the Equation Editor itself shows, since the Dry Run modal's own equation boxes
// deliberately show the minified one-liner instead (to avoid a scrollbar in the main flow).
const ViewFormattedEquationButton: FC<{ equationText: string }> = ({ equationText }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip title="View formatted equation">
        <Button
          type="text"
          size="small"
          icon={<EyeOutlined />}
          className="dryRunViewFormattedBtn"
          onClick={() => setIsOpen(true)}
        />
      </Tooltip>
      <Modal
        className="dryRunFormattedEquationModal"
        title="Formatted Equation"
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={<Button onClick={() => setIsOpen(false)}>Close</Button>}
        width={640}
        centered
      >
        <ReadOnlyEquationView value={formatEquation(equationText)} />
      </Modal>
    </>
  );
};

export default ViewFormattedEquationButton;
